import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import Menu from "../shared/Menu";
import Footer from "../shared/Footer";
import Modal from "../Modal/index";
import Dashboard from "./Dashboard";
import MemberInfo from "./MemberInfo";
import AccountInfo from "../MyProfile/AccountInfo";
import UpdateContact from "../MyProfile/UpdateContactInfo";
import ControlContact from "../MyProfile/ControlContactInfo";
import MemberDetail from "./MemberDetail";
import CreatePaymentOrder from "../PaymentOrder/CreatePaymentOrder";
import ListPayments from "../PaymentOrder/ListPayments";


import CreatePaymentOrderPayFor from "../PaymentOrderPayFor/CreatePaymentOrderPayFor";
import CreatePayment from "../Payment/CreatePayment";
// import ListPaymentsPayFor from "../PaymentOrderPayFor/ListPaymentsPayFor";


import MyReferences from "../References/MyReferences";
import SubmitReference from "../References/SubmitReference";
import ReferenceRules from "../References/ReferenceRules";
import SubmitDemand from "../Demands/SubmitDemand";
import MyDemands from "../Demands/MyDemands";
import Questions from "./Questions";
import AskToAgent from "../Agent/AskToAgent";
import ResetPassword from "./ResetPassword";
import AnnouncementDetail from "./AnnouncementDetail";
import SmartCalculation from "../Calculation/SmartCalculation";
import { history } from "../../../utilities/history";
import { Route, Switch, Router } from "react-router-dom";
import {
  beginLogout,
  selectAuthenticate
} from "../../../state/ducks/login/index";
import { selectAlertMessage } from "../../../state/ducks/alert/index";
import AgentInfo from "./AgentInfo";
import { selectDashboardInfo } from "../../../state/ducks/dashboard";
import AydinlatmaMetni from "../Modal/AydinlatmaMetni";
import SmsVerification from "../Calculation/SmsVerification";
import Result from "../Calculation/Result";
import PersonalInfo from "../Calculation/PersonalInfo";
import NewAddress from "../Calculation/NewAddress";
import CreditCardPayTR from "../PaymentOrderPayTR/CreditCardPayTR";
import CreatePaymentOrderPayTr from "../PaymentOrderPayTR/CreatePaymentOrderPayTr";
import CreatePaymentOrderEminPay from "../PaymentOrderEminPay/CreatePaymentOrderEminPay";

function changebg() {
  document.body.background = "";
  document.body.className = "t-dashboardBack";
}
function modalWithControl(Width) {

  var modalGenel = document.getElementById("id-modalTipi");
  var modalIptal = document.getElementById("id-modalIptal");
  if (modalGenel != null) {
    // ekranı sürekli dinle
    window.addEventListener("resize", function () {
      if (window.innerWidth < 900) {
        modalGenel.style.width = "90%"; // Modal Genişlipği
        if (modalIptal != null) {

          modalIptal.style.width = "90%"
        }
      } else {
        modalGenel.style.width = "55%"; // Modal Genişlipği
        if (modalIptal != null) {

          modalIptal.style.width = "30%";
        }
      }
    });

  }

}

class Home extends Component {
  state = {
    windowWidth: "0"
  }
  beginLogout = () => {
    this.props.beginLogout();
  };

  componentDidMount() {
    changebg();
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ windowWidth: window.innerWidth });

    //  modalWithControl(this.state.windowWidth)
  };

  render() {
    const { login, alert, dashboard } = this.props;
    return (
      <LoadingOverlay active={alert?.loading} spinner={<ClipLoader />} styles={{
        overlay: (base) => ({
          ...base,
          position: 'fixed'
        })
      }}>
        <Router history={history}>
          <Modal message={alert?.message} type={alert?.type} />
          <AydinlatmaMetni></AydinlatmaMetni>

          <div className="t-container ml-auto mr-auto">
            <div className="t-solMenuArea">
              <div className="t-solmenuicerik">
                <div className="container-fluid">
                  <div className="row pt-3" style={{ backgroundColor: "#242423" }}>
                    <div className="col-12 d-flex justify-content-end">
                      <img
                        src="/assets/img/svg/logo_internetSube.svg"
                        style={{ width: 70 }}
                      />
                    </div>
                  </div>
                  <div
                    className="row pb-4 pt-2 px-2 d-flex align-items-center"
                    style={{ backgroundColor: "#242423" }}
                  >
                    <div className="col-auto pr-1">
                      <img src="/assets/img/svg/icon_avatar.svg" style={{ width: 70 }} />
                    </div>
                    <div className="col d-flex flex-column px-1">
                      <span className="t-isim">{login.info.username}</span>
                      <span className="t-hosgeldiniz">Hoşgeldiniz</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0 t-solmenu">
                      <ul
                        className="accordion"
                        id="sol_menu"
                        style={{ padding: "0 0 50px 0" }}
                      >
                        <Menu count={dashboard.menuCount}></Menu>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="t-solMenuGuvenliCikis">
                <a href="#"
                  onClick={this.beginLogout}>
                  <i className="t-icon-switch" />
                  GÜVENLİ ÇIKIŞ
                </a>
              </div>
            </div>
            <div className="t-sagicerik">
              <div className="t-mobilMenuArea">
                <div className="t-mobilMenu">
                  <img src="/assets/img/svg/logo_internetSube.svg" style={{ height: 45 }} />
                  <a
                    className="t-icon-menu1"
                    data-toggle="collapse"
                    href="#mobilmenu"
                    style={{ fontSize: "30pt" }}
                  />
                </div>
              </div>
              <div className="t-MobilMenuAltArea">
                <div className="collapse" id="mobilmenu">
                  {/*  Mobil MENU */}
                  <div className="container-fluid" style={{ backgroundColor: "#302d2e" }}>
                    <div className="row p-2 d-flex align-items-center">
                      <div className="col-auto pr-1">
                        <img src="/assets/img/svg/icon_avatar.svg" style={{ width: 70 }} />
                      </div>
                      <div className="col d-flex flex-column px-1">
                        <span className="t-isim">{login.info.username}</span>
                        <span className="t-hosgeldiniz">Hoşgeldiniz</span>
                      </div>
                      <div className="col-auto t-mobilIconClose">
                        <a className="t-icon-switch" href="#" onClick={this.beginLogout} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 p-0 t-solmenu">
                        <ul
                          className="accordion"
                          id="ust_menu"
                          style={{ backgroundColor: "#3C3C3B" }}
                        >
                          <Menu count={dashboard.menuCount} ></Menu>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/*  Mobil MENU BİTTİ */}
                </div>
              </div>
              <Switch>
                <Route
                  exact
                  path="/Home/DashBoard"
                  render={props => <Dashboard login={login} {...props} />}
                />
                <Route
                  exact
                  path="/Home/MemberInfo"
                  component={MemberInfo}
                />
                <Route
                  exact
                  path="/Home/AccountInfo"
                  component={AccountInfo}
                />
                <Route exact path="/Home/AgentInfo" component={AgentInfo} />
                <Route
                  exact
                  path="/Home/MemberDetail/:id"
                  component={MemberDetail}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrder"
                  component={CreatePaymentOrder}
                />
                <Route
                  exact
                  path="/Home/ListPayments"
                  component={ListPayments}
                />

                <Route
                  exact
                  path="/Home/CreatePaymentOrderPayFor"
                  component={CreatePaymentOrderPayFor}
                />



                <Route
                  exact
                  path="/Home/CreatePayment"
                  render={props => <CreatePayment dashboard={dashboard} {...props} />}
                />

                {/* <Route
                  exact
                  path="/Home/ListPaymentsPayFor"
                  component={ListPaymentsPayFor}
                /> */}


                <Route
                  exact
                  path="/Home/SubmitReference"
                  component={SubmitReference}
                />
                <Route
                  exact
                  path="/Home/MyReferences"
                  component={MyReferences}
                />
                <Route
                  exact
                  path="/Home/ReferenceRules"
                  component={ReferenceRules}
                />
                <Route
                  exact
                  path="/Home/SubmitDemand"
                  component={SubmitDemand}
                />
                <Route exact path="/Home/MyDemands" component={MyDemands} />
                <Route exact path="/Home/Questions" component={Questions} />
                <Route
                  exact
                  path="/Home/AskToAgent"
                  component={AskToAgent}
                />
                <Route
                  exact
                  path="/Home/ResetPassword"
                  component={ResetPassword}
                />
                <Route
                  exact
                  path="/Home/AnnouncementDetail/:id"
                  component={AnnouncementDetail}
                />
                <Route
                  exact
                  path="/Home/SmartCalculation"
                  component={SmartCalculation}
                />
                <Route
                  exact
                  path="/Home/SmsVerification"
                  component={SmsVerification}
                />
                <Route
                  exact
                  path="/Home/PersonalInfo"
                  component={PersonalInfo}
                />
                <Route
                  exact
                  path="/Home/NewAddress"
                  component={NewAddress}
                />
                <Route
                  exact
                  path="/Home/Result"
                  component={Result}
                />
                <Route
                  exact
                  path="/Home/ControlContactInfo/:id"
                  component={ControlContact}
                />
                <Route
                  exact
                  path="/Home/UpdateContactInfo/:id"
                  component={UpdateContact}
                />
                <Route
                  exact
                  path="/Home/CreditCardPayTR"
                  component={CreditCardPayTR}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrderPayTr"
                  component={CreatePaymentOrderPayTr}
                />
                 <Route
                  exact
                  path="/Home/CreatePaymentOrderEminPay"
                  component={CreatePaymentOrderEminPay}
                />
              </Switch>
              <Footer></Footer>
            </div>

          </div>
        </Router>
      </LoadingOverlay>
    );
  }
}

const mapStateToProps = state => {
  return {
    login: selectAuthenticate(state),
    alert: selectAlertMessage(state),
    dashboard: selectDashboardInfo(state)
  };
};

const mapDispatchToProps = dispatch => ({
  beginLogout: () => dispatch(beginLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
export {
  history
};
